import { TApiButtonCommandFn } from ".";

import { SPINNER_ANIMATION_DURATION } from "components/SpinnerCheck/SpinnerCheck";
import { IApiArgument } from "config";
import { ModalKey } from "containers/Modals/modals";
import { SUCCESS_MODAL_DURATION } from "containers/Modals/Success/Success";
import { useModal } from "modules";
import { delay } from "utils/delay";

import { find } from "lodash-es";

// IApiArgument.name to find to display `source` value in overlay
const OVERLAY_ARGUMENT_TEXT_NAME: IApiArgument["name"] = "text";
const OVERLAY_ARGUMENT_MODAL_NAME: IApiArgument["name"] = "modal";
const OVERLAY_DURATION_BY_MODAL: Partial<Record<ModalKey, number>> = {
  ApplicationReceivedModal: SPINNER_ANIMATION_DURATION,
  Success: SUCCESS_MODAL_DURATION,
};

export const useShowSuccessOverlay = () => {
  const openModal = useModal();

  const showSuccessOverlayCommand: TApiButtonCommandFn = async commandArgs => {
    const overlayModal = find(commandArgs, ["name", OVERLAY_ARGUMENT_MODAL_NAME])
      ?.source as ModalKey;
    const overlayText = find(commandArgs, ["name", OVERLAY_ARGUMENT_TEXT_NAME])?.source;
    const overlayDuration = OVERLAY_DURATION_BY_MODAL[overlayModal] || SUCCESS_MODAL_DURATION;

    openModal(overlayModal || "Success", { text: overlayText });

    await delay(overlayDuration);
  };

  return showSuccessOverlayCommand;
};
